"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultipleChoice = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _Onboarding = require("@jobmatchme/ui/es/components/styleguide/Onboarding");

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Optimizers = require("../../utils/Optimizers");

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _FormFieldsBox = _interopRequireDefault(require("../FormFieldsBox"));

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _lkw40t = _interopRequireDefault(require("./icons/lkw-40t.svg"));

var _lkw40tS = _interopRequireDefault(require("./icons/lkw-40t-s.svg"));

var _lkw12t = _interopRequireDefault(require("./icons/lkw-12t.svg"));

var _lkw7t = _interopRequireDefault(require("./icons/lkw-7t.svg"));

var _5t = _interopRequireDefault(require("./icons/3_5t.svg"));

var _bus = _interopRequireDefault(require("./icons/bus.svg"));

var _5t2 = _interopRequireDefault(require("./icons/7_5t.svg"));

var _pkw = _interopRequireDefault(require("./icons/pkw.svg"));

var _roller = _interopRequireDefault(require("./icons/roller.svg"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// truck
// gastro
// image pool
var components = {
  CE: _lkw40t.default,
  C: _lkw40tS.default,
  C1E: _lkw12t.default,
  C1: _lkw7t.default,
  B: _5t.default,
  D: _bus.default,
  gastro_B: _pkw.default,
  gastro_C1: _5t2.default,
  gastro_AM: _roller.default
};
/**
 * MultipleChoice component for whitelabel registration funnel
 */

var MultipleChoiceComponent = function MultipleChoiceComponent(_ref) {
  var _context$config$value, _config$educationTool;

  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue; // For non primitive types, there might be conversion methods configured to break custom objects down to primitive types, that can be used in this component


  var toParamType = config.toParamType ? config.toParamType : function (a) {
    return a;
  };
  var fromParamType = config.fromParamType ? config.fromParamType : function (a) {
    return a;
  }; // If there is a parameter conversion between the components options and the non-primitive underlying type, we need to provide a custom equality method for state handling

  var equals = function equals(a, b) {
    return fromParamType(a) === fromParamType(b);
  };

  var handleChange = function handleChange(value) {
    if (typeof config.mutualOptions !== 'undefined' && typeof config.mutualOptions[value] !== 'undefined') {
      /*
       * extra handling to select or deselect multiple
       * checkboxes depending on the config passed
       */
      var changeset = config.mutualOptions[value].filter(function (item) {
        return item.value !== context[config.valueName].value.includes(item.key);
      }).map(function (item) {
        return toParamType(item.key);
      });
      setValue(config.valueName, [].concat((0, _toConsumableArray2.default)(changeset), [value]), equals);
    } else {
      setValue(config.valueName, toParamType(value), equals);
    }
  };

  var noneSet = ((_context$config$value = context[config.valueName].value // Actually check translated and flattened values for explicit occurrency in the config
  ) === null || _context$config$value === void 0 ? void 0 : _context$config$value.map(fromParamType).filter(function (value) {
    return Object.keys(config.options).includes(value);
  }).length) === 0;

  var unsetAll = function unsetAll() {
    if (!noneSet) setValue(config.valueName, context[config.valueName].value, equals);
  };

  var visibleFor = config.educationTooltip && config.educationTooltip.visibleFor;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.multipleChoice,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      toolTipVisible: visibleFor,
      text: config.translations.hint ? t(config.translations.hint) : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(_styleModule.default.wrapper, " ").concat((0, _Onboarding.targetClassName)((_config$educationTool = config.educationTooltip) === null || _config$educationTool === void 0 ? void 0 : _config$educationTool.target)),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormFieldsBox.default, {
        children: [Object.entries(config.options).map(function (_ref2) {
          var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
              option = _ref3[0],
              translation = _ref3[1];

          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _styleModule.default.row,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
              value: option,
              className: _styleModule.default.formControlLabel,
              labelPlacement: "end",
              control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
                value: option,
                className: _styleModule.default.chkBox,
                style: {
                  padding: '9px !important'
                },
                id: "".concat(config.valueName, "_box_").concat(option),
                inputProps: {
                  id: "".concat(config.valueName, "_box_").concat(option),
                  'aria-label': 'primary checkbox'
                },
                checked: context[config.valueName].value.map(fromParamType).includes(option),
                onChange: function onChange() {
                  return handleChange(option);
                },
                icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBoxOutlineBlank.default, {
                  className: _styleModule.default.sizeIconEmpty
                }),
                checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.default, {
                  className: _styleModule.default.sizeIconChecked,
                  color: "primary"
                })
              }, "".concat(config.valueName, "_box_").concat(option)),
              label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: _styleModule.default.label,
                children: [t(translation), (config.optionIcons || {})[option] && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  alt: config.optionIcons[option],
                  src: components[config.optionIcons[option]],
                  className: "".concat(_styleModule.default.icon, " ").concat(config.optionIconsClass ? _styleModule.default[config.optionIconsClass] : '')
                })]
              })
            })
          }, "".concat(config.valueName, "_").concat(option));
        }), config.unsetOption && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _styleModule.default.row,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
            className: _styleModule.default.formControlLabel,
            labelPlacement: "end",
            control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
              className: _styleModule.default.chkBox,
              style: {
                padding: '9px !important'
              },
              id: "".concat(config.valueName, "_box_unset"),
              inputProps: {
                id: "".concat(config.valueName, "_box_unset"),
                'aria-label': 'primary checkbox'
              },
              checked: noneSet,
              onChange: unsetAll,
              icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBoxOutlineBlank.default, {
                className: _styleModule.default.sizeIconEmpty
              }),
              checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.default, {
                className: _styleModule.default.sizeIconChecked,
                color: "primary"
              })
            }, "".concat(config.valueName, "_box_unset")),
            label: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _styleModule.default.label,
              children: t(config.translations.unsetOption)
            })
          })
        }, "".concat(config.valueName, "_unset"))]
      })
    })]
  });
};

var MultipleChoiceWrapper = (0, _Optimizers.memoizeComponentByValue)(MultipleChoiceComponent);

var MultipleChoice = function MultipleChoice(_ref4) {
  var config = _ref4.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MultipleChoiceWrapper, {
    config: config,
    context: context
  });
};

exports.MultipleChoice = MultipleChoice;